import { render, staticRenderFns } from "./EquipeLayout.vue?vue&type=template&id=b529141a&"
import script from "./EquipeLayout.vue?vue&type=script&lang=js&"
export * from "./EquipeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports